import React from 'react'
import "./LeagueCard.css"
import tennisBall from "../../assets/images/icone_bola.svg"
import { Row, Col } from 'react-bootstrap';


class LeagueCard extends React.Component {

    render() {
            return (
                        <Col xs={12} className={this.props.leagueNameClasses} onClick={this.props.onClick}>

                            { this.props.leaguePoster && <Row>
                              <Col xs={12} className={"p-0"}>
                                  <img className=" img-fluid" src={this.props.leaguePoster}/>
                              </Col>
                           </Row>}

                            <Row>
                            <Col xs={{ span: 8, offset: 2 }} className={"label"}>
                                {this.props.children}
                            </Col>
                           </Row>
                            <Row>
                                <Col xs={2} sm={2} className={"d-flex align-items-center"}>
                                    <img className="tennis-ball-logo tennis-ball-positioning img-fluid mx-auto" src={tennisBall} alt="tennis ball icon" />
                                </Col>
                                <Col xs={10} sm={10} className={"pl-0"}>
                                    <p className={"league-name-text"}>{this.props.leagueName}</p>
                                    <p className="league-date-text card-league-date-text">{this.props.leagueDate}</p>
                                </Col>
                            </Row>
                        </Col>
            )

    }
}

export default LeagueCard